<!--<input #input [(ngModel)]="value" type="number" (keydown)="onKeyDown($event)" style="width: 100%"/>-->
<div class="flex">
  <div class="p-fluid mr-3">
    <input
      #input
      (keydown)="onKeyDown($event)"
      [(ngModel)]="value"
      placeholder="0.00"
      style="width: 100%"
    />
<!--    <div class="p-fluid mr-3">-->
<!--      <p-inputNumber [(ngModel)]="value" mode="decimal" [minFractionDigits]="2" #inputNumber></p-inputNumber>-->
<!--    </div>-->
  </div>
  <div class="mr-1">
    {{unit}}
  </div>
</div>
